import AuthorCard from './_AuthorCard';
import RecipeCard from './_RecipeCard';
import StoryCard from './_StoryCard';
import CalloutGridCard from '@repo/ui/src/components/CalloutGridCard';

import { CalloutCard } from './styles';
import {
  AuthorProps,
  MediaType,
  ImageProps,
  MetaProps,
  RecipeMetaSectionProps,
  ToutContentProps,
  YoutubeLinkProps,
} from '@repo/ui/src/types';

interface CascadingCardProps {
  _testID: string;
  card: {
    avatar?: MediaType;
    featuredQuote?: string;
    id?: string;
    name?: string;
    author?: AuthorProps;
    assets?: Array<{
      endpoint: string;
      name: string;
    }>;
    toutContent: ToutContentProps;
    linkLabel?: string;
    recipeMetaSection?: RecipeMetaSectionProps;
    _meta: MetaProps;
    actionText?: string;
    categories?: any;
    description?: string;
    fullWidth?: boolean;
    image: ImageProps;
    title?: string;
    youtubeLink?: YoutubeLinkProps;
  };
  className: string;
  i: number;
  staticContent?: {
    author: {
      heading: string;
      link: string;
    };
    story: {
      heading: string;
      link: string;
      playButtonLabel: string;
    };
    recipe: {
      by: string;
      cookTimeLabel: string;
      effort: string;
      heading: string;
      link: string;
      prepTimeLabel: string;
    };
  };
}

const CascadingCard = ({ card, i, staticContent, className, _testID }: CascadingCardProps) => {
  const alignRight = i === 1;

  if (!card?._meta) return null;

  const calloutCard =
    card._meta.schema === 'https://traegergrills.com/data/contentTypes/calloutGridCard.json';

  const getCard = () => {
    switch (card._meta.schema) {
      case 'https://traegergrills.com/data/contentTypes/author.json':
        return <AuthorCard {...card} {...staticContent?.author} _testID={_testID} index={i} />;
      case 'https://traegergrills.com/data/contentTypes/story.json':
        return <StoryCard {...card} {...staticContent?.story} _testID={_testID} index={i} />;
      case 'https://traegergrills.com/data/contentTypes/recipe.json':
        return <RecipeCard {...card} {...staticContent?.recipe} _testID={_testID} index={i} />;
      case 'https://traegergrills.com/data/contentTypes/calloutGridCard.json':
        return <CalloutGridCard {...card} _testID={_testID} />;
      default:
        return null;
    }
  };

  return (
    <CalloutCard alignRight={alignRight} calloutCard={calloutCard} className={`${className}`}>
      {getCard()}
    </CalloutCard>
  );
};

export default CascadingCard;
